let store;

export const initializeInterceptor = (reduxStore) => {
  store = reduxStore;
};

export const handleResponse = async (response) => {
  if (response.status === 401) {
    try {
      const refreshed = await store.dispatch.user.refreshToken();
      if (refreshed) {
        const newToken = store.getState().user.access_token;
        const newRequest = new Request(response.url, {
          ...response,
          headers: new Headers({
            ...response.headers,
            'Authorization': `Bearer ${newToken}`
          })
        });
        return fetch(newRequest);
      }
    } catch (error) {
      await store.dispatch.user.logout();
      throw new Error('Session expired');
    }
  }
  return response;
};